module.exports = __webpack_public_path__ + "img/Sajjan_Kaur.2eb0d909.jpeg";